import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getStudentUpcomingAssListData } from "../../../Redux/action/StudentAction";
import axios from 'axios';
import toast from 'react-hot-toast';
import { useDispatch } from "react-redux";
import HourglassLoader from "../../../Common/HourglassLoader";


const host = process.env.REACT_APP_API_SERVER
const ObjectiveTestModal = ({
    ObjectiveTestModalData,
    loadObjectiveTestModalData,
    showObjectiveTestModal,
    handleClose,
}) => {

    const dispatch = useDispatch();

    const questions = ObjectiveTestModalData?.objective_questions || [];

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [timeRemaining, setTimeRemaining] = useState(ObjectiveTestModalData?.duration * 60); // 30 minutes in seconds
    const [isTestSubmitted, setIsTestSubmitted] = useState(false);
    const timerRef = useRef(null);

    // Formik setup
    const formik = useFormik({
        initialValues: questions.reduce(
            (acc, _, index) => ({ ...acc, [`question${index}`]: "" }),
            {}
        ),
        validationSchema: Yup.object(
            questions.reduce(
                (acc, _, index) => ({
                    ...acc,
                    // [`question${index}`]: Yup.string().required(`Question ${index + 1} is required`),
                }),
                {}
            )
        ),
        onSubmit: async (values) => {
            try {
                clearInterval(timerRef.current);
                setIsTestSubmitted(true);

                // Simulate closing the modal after 2 seconds
                setTimeout(() => {
                    handleClose();
                }, 2000);

                const transformedData = {
                    assessment_id: ObjectiveTestModalData?.id,
                    answerList: questions.map((question, index) => ({
                        question_id: question.id, // Use the unique `id` of the question
                        answer: values[`question${index}`] || "not attempted", // Default to "0" if no answer is selected
                    })),
                };





                const config = {
                    headers: {

                        "x-auth-token": localStorage.getItem('student-token'),
                    },
                };



                const response = await axios.post(
                    `${host}/api/student/assessment/submit-objective`,
                    transformedData,
                    config
                );

                if (response.status === 200) {

                    toast.success("Test submitted successfully");

                    dispatch(getStudentUpcomingAssListData());
                } else {

                    toast.error(response.data.message);
                }
            } catch (error) {

                console.error("Error:", error);
                toast.error(error.response.data.message);
            }

        },
    });

    const startTimer = () => {
        clearTimeout(timerRef.current); // Clear any existing timer
        setTimeRemaining(ObjectiveTestModalData?.duration * 60 || 30 * 60); // Set time or default to 30 mins

        const countdown = () => {
            setTimeRemaining((prev) => {
                if (prev > 1) {
                    timerRef.current = setTimeout(countdown, 1000); // Call countdown every second
                    return prev - 1;
                } else {
                    clearTimeout(timerRef.current);
                    if (!isTestSubmitted) {
                        formik.handleSubmit(); // Submit form only if not already submitted
                    }
                    return 0;
                }
            });
        };


        timerRef.current = setTimeout(countdown, 1000); // Start countdown
    };

    useEffect(() => {
        if (showObjectiveTestModal) {
            startTimer();
        } else {
            resetModalState();
        }

        return () => {
            clearTimeout(timerRef.current); // Cleanup timer
        };
    }, [showObjectiveTestModal]);

    const resetModalState = () => {
        setCurrentQuestionIndex(0);
        setIsTestSubmitted(false);
        formik.resetForm();
        clearTimeout(timerRef.current); // Clear timer on modal close
    };


    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
    };

    const handleNext = (event) => {
        event.preventDefault(); // Prevent any accidental form submission
        if (currentQuestionIndex < questions.length - 1) {
            setCurrentQuestionIndex((prev) => prev + 1);
        }
    };

    const handlePrev = (event) => {
        event.preventDefault();
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex((prev) => prev - 1);
        }
    };



    const progressBarWidth = ((ObjectiveTestModalData?.duration * 60 - timeRemaining) / (ObjectiveTestModalData?.duration * 60)) * 100;

    const currentQuestion = questions[currentQuestionIndex];

    return (
        <div
            className={`modal fade tutor-details-modal2 ${showObjectiveTestModal ? "show" : ""}`}
            id="test"
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden={!showObjectiveTestModal}
            style={{ display: showObjectiveTestModal ? "block" : "none" }}
        >
            <div className="modal-dialog modal-xl">
                <div className="modal-content h-75">
                    <div className="modal-header d-flex justify-content-between align-items-center">
                        <span id="time-left">{formatTime(timeRemaining)}</span>
                        <div className="progress-container">
                            <div className="progress">
                                <div
                                    id="progress-bar"
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{ width: `${progressBarWidth}%` }}
                                    aria-valuenow={progressBarWidth}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                />
                            </div>
                        </div>
                        <p className="text-white text-end">
                            <i className="bi bi-clock me-1" />
                            {ObjectiveTestModalData?.duration} min
                        </p>
                    </div>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="modal-body test-modal2">
                            <div className="question-card-container w-100 d-flex justify-content-center">
                                {currentQuestion ? (
                                    <div className="question-card active w-100">
                                        <h6>
                                            Question {currentQuestionIndex + 1}/{questions.length}
                                        </h6>
                                        <p>{currentQuestion.title}</p>
                                        <div className="options">
                                            {[
                                                { option: currentQuestion.first_option, key: "first_option" },
                                                { option: currentQuestion.second_option, key: "second_option" },
                                                { option: currentQuestion.third_option, key: "third_option" },
                                                { option: currentQuestion.fourth_option, key: "fourth_option" },
                                            ].map((choice, index) => (
                                                <label key={index}>
                                                    <input
                                                        type="radio"
                                                        name={`question${currentQuestionIndex}`}
                                                        value={choice.key} // Save the key (e.g., "first_option") instead of option text
                                                        checked={
                                                            formik.values[`question${currentQuestionIndex}`] === choice.key
                                                        }
                                                        onChange={formik.handleChange}
                                                        disabled={isTestSubmitted}
                                                    />{" "}
                                                    {choice.option}
                                                </label>
                                            ))}
                                            {formik.errors[`question${currentQuestionIndex}`] &&
                                                formik.touched[`question${currentQuestionIndex}`] && (
                                                    <div className="text-danger">
                                                        {formik.errors[`question${currentQuestionIndex}`]}
                                                    </div>
                                                )}
                                        </div>

                                    </div>
                                ) : (
                                    <p>No questions available</p>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer d-flex justify-content-between">
                            <button
                                id="prev-btn"
                                className="btn btn-outline-primary"
                                onClick={handlePrev}
                                disabled={currentQuestionIndex === 0 || isTestSubmitted}
                                type="button"
                            >
                                Previous
                            </button>
                            {currentQuestionIndex < questions.length - 1 ? (
                                <button
                                    id="next-btn"
                                    className="btn btn-outline-primary"
                                    onClick={handleNext}
                                    disabled={isTestSubmitted}
                                    type="button"
                                >
                                    Next
                                </button>
                            ) : (
                                <button
                                    id="submit-btn"
                                    className="btn btn-success"
                                    type="submit"
                                    disabled={!formik.isValid || !formik.dirty || isTestSubmitted}
                                >

                                    {formik.isSubmitting ? <HourglassLoader /> : 'Submit'}
                                </button>
                            )}
                            {/* <button
                                id="closeModalButton"
                                className="btn btn-secondary"
                                onClick={handleClose}
                                type="button"
                            >
                                Close
                            </button> */}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ObjectiveTestModal;
